import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Guid } from 'guid-typescript';

@Injectable({
    providedIn: 'root'
})
export class SelectedBarService {
    private selectedBarIdSubject = new BehaviorSubject<Guid | null>(null);
    public selectedBarId$ = this.selectedBarIdSubject.asObservable();

    setSelectedBarId(barId: Guid | null): void {
        this.selectedBarIdSubject.next(barId);
    }

    getSelectedBarId(): Guid | null {
        return this.selectedBarIdSubject.value;
    }
}
